import { PageId } from 'constants/pages'

export const enum PageIdWoofzPt1Bg {
  DOG_SEX_PT1_BG = PageId.DOG_SEX_PT1_BG,
  DOG_AGE_PT1_BG = PageId.DOG_AGE_PT1_BG,
  SHELTER_PT1_BG = PageId.SHELTER_PT1_BG,
  DOG_BREED_PT1_BG = PageId.DOG_BREED_PT1_BG,
  URGE_PT1_BG = PageId.URGE_PT1_BG,
  STARTED_PT1_BG = PageId.STARTED_PT1_BG,
  PLACE_PT1_BG = PageId.PLACE_PT1_BG,
  GOALS_PT1_BG = PageId.GOALS_PT1_BG,
  ACCIDENTS_PT1_BG = PageId.ACCIDENTS_PT1_BG,
  CONCERNS_PT1_BG = PageId.CONCERNS_PT1_BG,
  URGE_2_PT1_BG = PageId.URGE_2_PT1_BG,
  LIVING_SITUATION_PT1_BG = PageId.LIVING_SITUATION_PT1_BG,
  POTTY_BREAKS_PT1_BG = PageId.POTTY_BREAKS_PT1_BG,
  CRATE_TRAINING_PT1_BG = PageId.CRATE_TRAINING_PT1_BG,
  COMMANDS_PT1_BG = PageId.COMMANDS_PT1_BG,
  TRAINING_TIME_PT1_BG = PageId.TRAINING_TIME_PT1_BG,
  PREPARE_FLOW_PT1_BG = PageId.PREPARE_FLOW_PT1_BG,
  COMMITMENT_SCREEN_PT1_BG = PageId.COMMITMENT_SCREEN_PT1_BG,
  EMAIL_PT1_BG = PageId.EMAIL_PT1_BG,
  NEWSLETTER_URGE_PT1_BG = PageId.NEWSLETTER_URGE_PT1_BG,
  SUBSCRIPTIONS_PT1_BG = PageId.SUBSCRIPTIONS_PT1_BG,
  CANCEL_OFFER_PT1_BG = PageId.CANCEL_OFFER_PT1_BG,
  CHAT_UPSELL_PT1_BG = PageId.CHAT_UPSELL_PT1_BG,
  UPSELL_PT1_BG = PageId.UPSELL_PT1_BG,
  UPSELL_FEEDING_GUIDE_PT1_BG = PageId.UPSELL_FEEDING_GUIDE_PT1_BG,
  UPSELL_EMOTIONAL_SUPPORT_PT1_BG = PageId.UPSELL_EMOTIONAL_SUPPORT_PT1_BG,
  DOWNLOAD_PT1_BG = PageId.DOWNLOAD_PT1_BG,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
